import * as Yup from "yup";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { MdmAddActivityFormKeys } from "./models";
import { MDM_ACTIVITY_SEARCH_TYPE_KEY } from "../../../helpers/constants";
import { specialCharactersNotAllowedValidation } from "../../../helpers/constants/commonValidationSchemaUtils";

export const MdmAddActivitySchema = (
  commonValidationMessages: KeyValueMap,
  searchType: string,
) => {
  const frameworkArray = Yup.array().of(Yup.string().required()).default([]);
  return Yup.object().shape({
    [MdmAddActivityFormKeys.activityName]:
      specialCharactersNotAllowedValidation(
        commonValidationMessages.requiredValidation,
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ),
    [MdmAddActivityFormKeys.programFramework]:
      searchType === MDM_ACTIVITY_SEARCH_TYPE_KEY.program
        ? frameworkArray.min(1, commonValidationMessages.requiredValidation)
        : frameworkArray.optional(),
    [MdmAddActivityFormKeys.projectFramework]:
      searchType === MDM_ACTIVITY_SEARCH_TYPE_KEY.project
        ? frameworkArray.min(1, commonValidationMessages.requiredValidation)
        : frameworkArray.optional(),
    [MdmAddActivityFormKeys.modality]: Yup.array()
      .of(Yup.string().required())
      .min(1, commonValidationMessages.requiredValidation)
      .default([]),
    [MdmAddActivityFormKeys.units]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
  });
};
